<template>
  <q-dialog
    maximized
    v-model="show"
    transition-show="fade"
    transition-hide="fade"
  >
    <q-card class="bg-indigo-6">
      <q-card-section class="absolute-center full-width">
        <div class="text-h5 pc-bold text-white text-center">
          {{ returnRandomMessage() }}
        </div>
        <div class="row">
          <q-space />
          <q-spinner-dots color="amber-6" size="4.5em" />
          <q-space />
        </div>

        <!-- <q-btn label="close" color="amber-6" @click="display = false" /> -->
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: ["show"],
  data() {
    return {
      messages: [
        "Opening crate!",
        "Taking off the lid!",
        "Pulling out the screws!",
        "Unloading crate!",
        "Unpacking content!",
        "Opening padlock!",
      ],
    };
  },
  methods: {
    returnRandomMessage() {
      let position = Math.floor(Math.random() * this.messages.length);
      return this.messages[position];
    },
  },
};
</script>

<style>
.pc-loading-bg {
  background: radial-gradient(
    circle at center,
    #9a7de8 -50%,
    #3f51b5
  ) !important;
}
</style>
